import { render, staticRenderFns } from "./OrderId.vue?vue&type=template&id=1f019628&scoped=true"
import script from "./OrderId.vue?vue&type=script&lang=js"
export * from "./OrderId.vue?vue&type=script&lang=js"
import style0 from "./OrderId.vue?vue&type=style&index=0&id=1f019628&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f019628",
  null
  
)

export default component.exports